import React, { useContext, useEffect } from "react";
import {  Route, Routes, Navigate,useLocation } from "react-router-dom";
//import is from "is_js";
import MainLayout from "./MainLayout";
import SettingsPanel from "../components/settings-panel/SettingsPanel";
import NoInternetConnection from '../components/utilities/NoInternetConnection';
import AppContext from "context/Context";
import useNetworkMonitor from "../hooks/useNetworkMonitor";


const Layout = () => {
  const {config: { isDark }} = useContext(AppContext);
  
  useNetworkMonitor();

  // useEffect(() => {
  //   if (is.windows()) {
  //     HTMLClassList.add("windows");
  //   }
  //   if (is.chrome()) {
  //     HTMLClassList.add("chrome");
  //   }
  //   if (is.firefox()) {
  //     HTMLClassList.add("firefox");
  //   }
  // }, [HTMLClassList]);
   

  return (
    <>
    <MainLayout />
    <SettingsPanel />
    <NoInternetConnection />
    </>
  );
};

export default Layout;
